import { PayloadAction, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

const StoragePrefix = 'mapview-';

export interface MapData {
  siteId: string;
  centreLat: number;
  centreLon: number;
  zoom: number;
}

const getPersistedData = (): MapData[] => {
  const keys = Object.keys(window.localStorage).filter(k => k.startsWith(StoragePrefix));
  const mapData: MapData[] = [];

  keys.forEach(k => {
    try {
      const item = window.localStorage.getItem(k);
      const data = item ? JSON.parse(item) : undefined;

      if (data) {
        mapData.push(data);
      }
    } catch {
      // Swallow
    }
  });

  return mapData;
};

const writePersistedData = (data: MapData) => {
  try {
    const name = `${StoragePrefix}${data.siteId}`;
    window.localStorage.setItem(name, JSON.stringify(data));
  } catch {
    // Swallow
  }
};

const mapAdapter = createEntityAdapter({
  selectId: (map: MapData) => map.siteId,
  sortComparer: (a, b) => a.siteId.localeCompare(b.siteId),
});

const mapSlice = createSlice({
  name: 'map',
  initialState: mapAdapter.getInitialState(undefined, getPersistedData()),
  reducers: {
    setView(state, action: PayloadAction<MapData>) {
      mapAdapter.upsertOne(state, action.payload);
      writePersistedData(action.payload);
    },
  },
});

export const { setView } = mapSlice.actions;
export default mapSlice.reducer;

export const { selectById: selectMapDataBySiteId } = mapAdapter.getSelectors(
  (state: RootState) => state.map,
);
